<ng-container *ngIf="col.type === 'input-text'">
    <input select-all
        (change)="onChangeData()"
        pInputText type="text"
        [formControl]="rawmaterialForm.controls[col.field]"
        [placeholder]="(col.placeholderFieldId) ?  rowData[col.placeholderFieldId] : ''"
        [pattern]="col.pattern"
        [matTooltip]="getTooltipMessage(rawmaterialForm.controls[col.field])"
        matTooltipPosition="below"
        matTooltipClass="tooltip-error"
        [ngClass]="{'valid-color': !rawmaterialForm.controls[col.field].invalid && hasChange}"
        [(ngModel)]="rowData[col.field]">
</ng-container>

<ng-container *ngIf="col.type === 'input-textarea'">
    <textarea select-all
        pInputTextaera type="textarea"
        [formControl]="rawmaterialForm.controls[col.field]"
        [placeholder]="(col.placeholderFieldId) ?  rowData[col.placeholderFieldId] : ''"
        [pattern]="col.pattern"
        [matTooltip]="getTooltipMessage(rawmaterialForm.controls[col.field])"
        [ngClass]="{'valid-color': !rawmaterialForm.controls[col.field].invalid && hasChange}"
        matTooltipPosition="below"
        matTooltipClass="tooltip-error"
        [(ngModel)]="rowData[col.field]">
        </textarea>
</ng-container>


<ng-container *ngIf="col.type === 'select'">
    <neq-select-autocomplete #select
        [placeholder]="(col.placeholderFieldId) ?  rowData[col.placeholderFieldId] : ''"
        [matTooltip]="getTooltipMessage(rawmaterialForm.controls[col.field])"
        matTooltipPosition="below"
        matTooltipClass="tooltip-error"
        [redColor]="rawmaterialForm.controls[col.field].invalid"
        [validColor]="!rawmaterialForm.controls[col.field].invalid && hasChange"
        [paginatedResults]="col.field === 'referenceLabel'"
        bindLabel="label"
        [dataSource]="fetchData"
        [(ngModel)]="ngModel"
        (change)="changeSelectedElement($event)">
    </neq-select-autocomplete>
 </ng-container>

 <ng-container *ngIf="col.type === 'input-nutrient' && currentNutrient">
    <input select-all
        pInputText type="number"
        [matTooltip]="getTooltipNutrient()"
        matTooltipPosition="below"
        [ngClass]="{'valid-color': hasChange}"
        (change)="onNutrientChange()"
        [(ngModel)]="currentNutrient.value">
 </ng-container>